import qs from 'qs';
import _ from 'lodash';
import queryStringParseOptions from './queryStringParseOptions';

export const pathsWithQuery = (path, query) => {
  const queryString = qs.stringify(query, queryStringParseOptions);
  return _.isEmpty(queryString) ? path : `${path}?${queryString}`;
};
